module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-4\">\n      <p>\n        <a href=\"data_sources/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Data Source</a>\n      </p>\n      <div class=\"list-group\">\n        <a ng-href=\"data_sources/{{dataSource.id}}\" class=\"list-group-item\" ng-repeat=\"dataSource in dataSources\"><i class=\"fa fa-database\"></i> {{dataSource.name}}</a>\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/data-sources/list.html
// module id = 768
// module chunks = 1